module.exports = __webpack_public_path__ + "static/img/content-pixie-a_boMVYTvT4-unsplash_thumb.8201954.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/content-pixie-a_boMVYTvT4-unsplash_thumb.png
// module id = 7gQT
// module chunks = 4